/** Imprime etiquetas com QR (serviço público) + código legível. */
export function imprimirEtiquetasQr(items, titulo = 'Etiquetas') {
  const cards = (items || [])
    .map((it) => {
      const payload = encodeURIComponent(it.qr_payload || it.codigo || '');
      const linhas = (it.linhas || []).map((l) => `<div class="ln">${esc(l)}</div>`).join('');
      return `<div class="card">
        <div class="cod">${esc(it.titulo || it.codigo || '')}</div>
        <img alt="QR" src="https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${payload}" />
        ${linhas}
        <div class="tiny">${esc(it.qr_payload || '')}</div>
      </div>`;
    })
    .join('');

  const w = window.open('', '_blank', 'width=900,height=700');
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>${esc(titulo)}</title>
    <style>
      body{font-family:Arial,sans-serif;margin:16px}
      h1{font-size:16px}
      .grid{display:flex;flex-wrap:wrap;gap:16px}
      .card{width:240px;border:1px solid #111;padding:10px;text-align:center;page-break-inside:avoid}
      .cod{font-weight:700;font-size:15px;margin-bottom:6px;word-break:break-all}
      .ln{font-size:12px;color:#222}
      .tiny{font-size:8px;color:#666;margin-top:6px;word-break:break-all}
      img{width:180px;height:180px}
      @media print {.noprint{display:none}}
    </style></head><body>
    <h1>${esc(titulo)}</h1>
    <p class="noprint"><button onclick="window.print()">Imprimir</button></p>
    <div class="grid">${cards}</div>
    </body></html>`);
  w.document.close();
}

function esc(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function copiarTexto(texto) {
  return navigator.clipboard?.writeText(String(texto || ''));
}

export function etiquetaPosicao(p) {
  return {
    codigo: p.endereco,
    titulo: p.endereco,
    qr_payload: p.qr_payload,
    linhas: [
      `Câmara ${p.camara_codigo || ''} · Rua ${p.rua_codigo || ''}`,
      `Estante ${p.estante_codigo || ''} · Andar ${p.andar_codigo || ''}`,
      `Porta-pallet ${p.codigo || ''}`
    ]
  };
}

export function etiquetaPallet(p) {
  return {
    codigo: p.codigo,
    titulo: p.codigo,
    qr_payload: p.qr_payload,
    linhas: [
      p.produto_nome,
      `Lote ${p.lote_fornecedor || '—'}`,
      `Val. ${p.data_validade || '—'} · ${p.quantidade} ${p.unidade || ''}`,
      p.fornecedor || ''
    ]
  };
}
